import { settingsProfile, SettingsProfileState } from "./settingsProfile.reducer";
import { combineReducers } from "redux";

export interface SettingsState {
    profile: SettingsProfileState;
}

export const settings = combineReducers({
    profile: settingsProfile,
});